const switchBtns = document.querySelectorAll(".button-switch_btn");

function moveBackground(pos){
	let bg = document.querySelector(".button-switch--bg"); 
	let currentLeft = parseInt(bg.style.left);
	let newLeft = (100 / switchBtns.length) * pos;
	bg.style.left = newLeft+"%"; 
}

function toggleButtonActive(btn){
	switchBtns.forEach(function(btn){
		btn.classList.remove("button-switch__active");
	});
	if(btn.classList.contains("button-switch__active")){
		btn.classList.remove("button-switch__active");
	}else{
		btn.classList.add("button-switch__active");
	}
}

switchBtns.forEach(function(btn,i){
	btn.addEventListener('click', function(){
		toggleButtonActive(btn); 
		moveBackground(i);
	})
});